import app from '@frontend/application-container';
import { SettingsEntry } from '../settings-entry';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Right/import-export/delete_2_vertices_on_export.svg';
import { img } from '@phi/components';
import FormToggle from '@frontend/components/FormToggle';
import { h } from 'vue';

export function SplitEdges() {
    return SettingsEntry(
        'Split edges on export',

        'When on, vertices lying on exactly 2 edges will also be exported to Onshape. When off, consecutive edges will be exported as a single edge.',

        img(icon, 'Split edges on export'),

        h(FormToggle, {
            value: app.settings.split_faces,
            'onUpdate:value': x => app.settings.split_faces = x,
        }),
    );
}
